export class Questions {
  id: number = 0;
  // tslint:disable-next-line:variable-name
  question_name: string = '';
  // tslint:disable-next-line:variable-name
  question_text: string = '';
  // tslint:disable-next-line:variable-name
  question_version: string = '1';
  // tslint:disable-next-line:variable-name
  rubric_type: string = 'Binary';
  // tslint:disable-next-line:variable-name
  development_status: string = 'progress';
  // tslint:disable-next-line:variable-name
  brief_rubric_description: string = '';
  // tslint:disable-next-line:variable-name
  brief_scoring_description: string = '';
  questionVersions: Array<number> = [];
  rubricLevels: Array<RubricBins> = []
  revision_date: string = new Date().toLocaleDateString();
  question_archived: boolean = false;
  disabled: boolean = false;

  isAnalytic() {
    return this.rubric_type.toLocaleLowerCase() === "binary";
  }

  isHolistic() {
    return !this.isAnalytic();
  }
}

export class RubricBins {
  // tslint:disable-next-line:variable-name
  id: number;
  // tslint:disable-next-line:variable-name
  rubric_code: string;
  // tslint:disable-next-line:variable-name
  rubric_level: string;
  // tslint:disable-next-line:variable-name
  question_id: number;
  // tslint:disable-next-line:variable-name
  description: string;
  // tslint:disable-next-line:variable-name
  brief_rubric_description: string;
  // tslint:disable-next-line:variable-name
  brief_scoring_description: string;
  // tslint:disable-next-line:variable-name
  short_code: string;

  constructor(index: number) {
    this.short_code = `BIN${index}`;
  }
}

export class QuestionCategory {
  // tslint:disable-next-line:variable-name
  question_id: number;
  name: string;
  relation: string;
  description: string;
}

export class Rubrics {
  id: number;
  question_id: number;
  rubric_code: string;
  description: string;
  rubric_level: string;
}
